module.exports = __webpack_public_path__ + "img/code-analysis.d99dd2b5.jpeg";